<template>
  <div v-bind="$attrs">

    <v-label
      v-if="label"
      :editable="editableLabel"
      :text="label"
      @update="$emit('update:label', $event)">
    </v-label>

    <div class="field has-addons">
      <p v-for="(option, i) in options" :key="i" class="control">
        <button 
          class="button"
          type="button"
          :class="value === option.value ? 'is-primary is-light' : ''" 
          @click="$emit('input', option.value)"
        >
          <span v-if="option.icon" class="icon is-small">
            <i :class="option.icon"></i>
          </span>
          <span>{{ option.label }}</span>
        </button>
      </p>
    </div>

    <div class="level" v-if="hasError">
      <div class="help has-text-danger pl-1">
        <div 
          v-for="(error, i) in errors"
          :key="i">
          {{ error }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VLabel from '@/components/base/VLabel'
import validatable from '@/mixins/validatable'
import helpers from '@/helpers'

export default {
  props: {
    value: {
      type: [String, Number, Object, Boolean]
    },
    itemText: {
      type: [String, Function]
    },
    itemValue: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: [String, Number],
      default: null
    },
    editableLabel: {
      type: Boolean,
      default: false
    },
    isFullwidth: {
      type: Boolean,
      default: true
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isMedium: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  components: { VLabel },
  mixins: [validatable],
  data() {
    return {
      isFunction: helpers.isFunction
    }
  },
  computed: {
    hooks() {
      return {
        ...this.$listeners
      }
    }
  },
  methods: {
    select(v) {
      this.$emit('input', v);
      this.validate(v);
    },
    blur(v) {
      this.$emit('blur', v);
      this.validate(v);
    }
  }
}
</script>

<style scoped>
</style>
